export function decodeQS(str: string, decodeParams: boolean): {[k:string]: string} {

    const rval: {[k: string]: string} = {};
    if(str && str.length > 0) {
        str.split("&").map(e => e.split("=").map(el=> {
            if(decodeParams) return decodeURIComponent(el);
            else el;
        })).forEach(coup => {
            rval[coup[0]] = coup[1];
        });
    }
    
    return rval;
}


export function getQSParam(location: Location , param: string, decodeParams: boolean): string | null {
    const qsObj = decodeLocationQS(location,decodeParams);
    if(param in qsObj) {
        return qsObj[param];
    }
    else return null;
}

export function decodeLocationQS(location: Location ,decodeParams: boolean): {[k:string]: string} {
    const search = location.search;
    if(search.trim() != "" && search.startsWith("?")) {
        return decodeQS(search.substring(1),decodeParams);
    }
    else return {};
}

export function encodeQS(obj: {[k: string]: any},encodeParams: boolean): string {
    let composed: [string,string][] = [];

    for(const key in obj) {
        composed.push([key,obj[key]]);
    }
    return composed.map(e => e.map(v => encodeParams?encodeURIComponent(v):v).join("=")).join("&");

}


export function appendInQs(url: string, data: string): string {
    let modUrl = url;
    if(data && data.trim() != ""){
        modUrl = url + (url.indexOf("?") > 0? "&":"?") + data;
    }
    return modUrl;
}
